export * from './typography.component.style';
